import type { LOCATION_SEARCH_TYPE, ProductType } from '@/types'
import type { SearchFormProductHeadlineType } from '@/components/SearchForm/types'
import SearchForm from '@/components/Hotels/HorizonForm/HorizonHotelForm'
import FlightForm from '@/components/Flights/HorizonForm/HorizonFlightForm'
import { handleSubmitForHotels } from '@/components/Hotels/SearchForm/utils'

import { onSubmit as onSubmitFlight } from '@/components/Flights/SearchForm/utils'
import CarsForm from '@/components/Cars/HorizonForm/HorizonCarForm'
import HorizonPackagesForm from '@/components/Packages/HorizonForm/HorizonPackagesForm'
import { onSubmit } from '@/components/Packages/SearchForm/utils'
import HorizonCruiseForm from '@/components/Cruises/HorizonForm/HorizonCruiseForm'
import {
  CarsBumper,
  CruiseBumper,
  FlightsBumper,
  HotelsBumper,
  VacationBumper
} from '../../SearchForm/Bumpers'

export default function getProductCategory(
  productType: ProductType,
  values: SearchFormProductHeadlineType,
  setLocation?: (key: LOCATION_SEARCH_TYPE | undefined) => void,
  showHotelTypeButtons?: boolean
) {
  switch (productType) {
    case 'flights':
      return {
        component: (
          <FlightForm
            onSubmit={onSubmitFlight}
            pageName="homepage"
            useCompactLayout
          />
        ),
        bumper: <FlightsBumper />,
        headline: values.flights.headline
      }
    case 'cars':
      return {
        component: <CarsForm useCompactLayout />,
        bumper: <CarsBumper />,
        headline: values.cars.headline
      }
    case 'vacations':
      return {
        component: (
          <HorizonPackagesForm
            pageName="homepage"
            onSubmit={onSubmit}
            useCompactLayout
          />
        ),
        bumper: <VacationBumper />,
        headline: values.vacations.headline
      }

    case 'cruises':
      return {
        component: <HorizonCruiseForm useCompactLayout />,
        bumper: <CruiseBumper richText={values.cruises.bumper} />,
        headline: values.cruises.headline
      }

    default:
      return {
        component: (
          <SearchForm
            onSubmit={handleSubmitForHotels}
            setLocation={setLocation}
            showHotelTypeButtons={showHotelTypeButtons}
            pageName="homepage"
            useCompactLayout
          />
        ),
        bumper: <HotelsBumper />,
        headline: values.hotels.headline
      }
  }
}
